import React from "react";
import PropTypes from "prop-types";

/**
 * Healthcare — Tailwind version of your KPI cards
 *
 * Props:
 *  - healthCareData: array of { icon: ReactNode, title: string, value: string, sub?: string }
 *  - themeColor: Tailwind color suffix (defaults to "blue-600")
 */
export default function NumberCards({ healthCareData = [], themeColor = "blue-600", cardmainTitle }) {
	const colorClass = `text-${themeColor}`;
	const bgClass = `bg-${themeColor.replace("-600", "-50")}`; // e.g. blue-50 fallback
	// If your Tailwind config doesn't generate these dynamic classes, replace with fixed classes like "text-blue-600" / "bg-blue-50".

	return (
		<section aria-labelledby="healthcare-heading" className="w-full">
			<div className="grid gap-2 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-1">
				{healthCareData.map((item, idx) => (
					<article
						key={idx}
						className="flex items-center justify-between gap-2 p-1.5 bg-white border border-slate-100 rounded-md shadow-sm hover:shadow-md transition-shadow duration-200"
						role="group"
						aria-label={`${item.title} card`}
					>
						{/* Icon avatar */}
						<div
							className={`flex items-center justify-center w-9 h-9 rounded-full shrink-0 
                      ${item.colorBg || "bg-gradient-to-r from-indigo-500 to-purple-500"} 
                      text-white`}
							aria-hidden="true"
						>
							{React.isValidElement(item.icon)
								? React.cloneElement(item.icon, { className: "w-4 h-4" })
								: <span className="w-4 h-4" />}
						</div>

						{/* Text block */}
						<div className="flex-1 text-right ml-1">
							<div className="text-xs font-medium text-slate-500">{item.title}</div>
							<div className="mt-0.25 text-sm font-bold text-gray-800 break-words">{item.value}</div>
							{item.sub && (
								<div className="mt-0.25 text-[10px] text-slate-400">{item.sub}</div>
							)}
						</div>
					</article>
				))}
			</div>
		</section>


	);
}

NumberCards.propTypes = {
	healthCareData: PropTypes.arrayOf(
		PropTypes.shape({
			icon: PropTypes.node.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			sub: PropTypes.string,
		})
	),
	themeColor: PropTypes.string,
};

NumberCards.defaultProps = {
	healthCareData: [],
	themeColor: "blue-600",
};
